var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 66,
    viewBox: "0 0 57 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6024 0H40.6975L56.9407 16.5407V61.4031C56.9407 63.9615 54.8583 65.9845 52.3593 65.9845H11.6024C9.04397 65.9845 7.021 63.9615 7.021 61.4031V4.64093C7.021 2.08247 9.04397 0 11.6024 0Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9407 16.5407H44.8624C42.5419 16.5407 40.6379 14.6368 40.6379 12.3163V0H40.6974L56.9407 16.5407Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9406 16.5407V28.6786L45.0408 16.5407H56.9406Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7548 30.9922H2.43946C1.09218 30.9922 0 32.0312 0 33.3127V52.7689C0 54.0505 1.09218 55.0894 2.43946 55.0894H45.7548C47.1021 55.0894 48.1943 54.0505 48.1943 52.7689V33.3127C48.1943 32.0312 47.1021 30.9922 45.7548 30.9922Z",
    fill: "#E37918"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2004 44.4444H12.6643V42.8448H15.2004C15.5924 42.8448 15.9114 42.781 16.1575 42.6534C16.4036 42.5212 16.5836 42.3389 16.6975 42.1065C16.8114 41.8741 16.8684 41.612 16.8684 41.3204C16.8684 41.0241 16.8114 40.7484 16.6975 40.4932C16.5836 40.238 16.4036 40.0329 16.1575 39.878C15.9114 39.723 15.5924 39.6456 15.2004 39.6456H13.3752V47.9922H11.3245V38.0391H15.2004C15.9797 38.0391 16.6474 38.1804 17.2034 38.463C17.7639 38.7409 18.1923 39.126 18.4885 39.6182C18.7847 40.1104 18.9329 40.6732 18.9329 41.3067C18.9329 41.9493 18.7847 42.5053 18.4885 42.9747C18.1923 43.4441 17.7639 43.8064 17.2034 44.0616C16.6474 44.3168 15.9797 44.4444 15.2004 44.4444Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4239 44.4444H21.8877V42.8448H24.4239C24.8158 42.8448 25.1348 42.781 25.3809 42.6534C25.627 42.5212 25.807 42.3389 25.9209 42.1065C26.0349 41.8741 26.0918 41.612 26.0918 41.3204C26.0918 41.0241 26.0349 40.7484 25.9209 40.4932C25.807 40.238 25.627 40.0329 25.3809 39.878C25.1348 39.723 24.8158 39.6456 24.4239 39.6456H22.5987V47.9922H20.5479V38.0391H24.4239C25.2032 38.0391 25.8708 38.1804 26.4268 38.463C26.9874 38.7409 27.4157 39.126 27.712 39.6182C28.0082 40.1104 28.1563 40.6732 28.1563 41.3067C28.1563 41.9493 28.0082 42.5053 27.712 42.9747C27.4157 43.4441 26.9874 43.8064 26.4268 44.0616C25.8708 44.3168 25.2032 44.4444 24.4239 44.4444Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2215 38.0391V47.9922H32.1776V38.0391H34.2215ZM37.284 38.0391V39.6456H29.1629V38.0391H37.284Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1944 52.7757V55.0367C48.1944 56.3456 47.1234 57.3571 45.8144 57.3571H7.021V55.0962H45.8144C47.1234 55.0962 48.1944 54.0252 48.1944 52.7757Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/PPT.4953b0804badb031dac0505af6a580c3.svg";
export { ForwardRef as ReactComponent };